
import _memoize from "lodash/memoize"
import log from "plugins/loglevel/index"
import Promise from "plugins/bluebird"
// directly from library log as our warpped log depends on this file

import DataRetriever from "app/data_retriever/lite"

/* eslint-disable no-unused-vars */
export enum Environments {
  UNKNOWN =      "unknown",
  DEVELOPMENT =  "development",
  TEST =         "test",
  STAGING =      "staging",
  PRODUCTION =   "production",
}
/* eslint-enable no-unused-vars */

interface CurrentEnvResult {
  current_environment: Environments,
}

let rails_env: Environments = Environments.UNKNOWN

const _init: (() => Promise<CurrentEnvResult>) = () => {
  return new Promise((resolve) => {
    const rails_env_from_data: any = DataRetriever.get("rails-env")
    if (rails_env_from_data == null) {
      log.error("Data attribute rails-env is missing!")
    }
    if (!Object.values(Environments).includes(rails_env_from_data)) {
      log.error(`Data attribute rails-env is invalid! <${rails_env_from_data}>`)
    }
    else {
      rails_env = rails_env_from_data
    }

    resolve({
      current_environment: rails_env,
    })
  })
}

const init = _memoize(_init)


export default {
  init,
  Environments,

  isDevelopment:  () => rails_env === Environments.DEVELOPMENT,
  isTest:         () => rails_env === Environments.TEST,
  isStaging:      () => rails_env === Environments.STAGING,
  isProduction:   () => rails_env === Environments.PRODUCTION,
}
